import jsPDF from 'jspdf';
import moment from 'moment';
import { drawCabeceraLogo, drawFooterEmpresa } from './empresa_pdf';

/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */


export default {
  methods: {
    exportPDFComisionesVendedor (resumen, empresa) {
      let pdfName = 'resumen_comisiones'; 
      /* Parametros: portrait, milimetros, A4 */
      let doc = new jsPDF('p', 'mm', 'a4');
      let pages = 1;

      doc.setProperties({
        title: 'Resumen de Movimientos',
        subject: 'Resumen de Movimientos',		
        author: 'Cervertti - Marketing & Eventos',
        creator: 'Cervetti'
      });

      let fontName = 'Montserrat-Regular';
      let fontBoldName = 'Montserrat-Bold';
      let fontItalicName = 'Montserrat-Italic';
      let fontBoldItalicName = 'Montserrat-BoldItalic';

      /* Inicial renglones */
      let positionRenglonesY = 65;
      /* Limite para el salto de página */
      let positionMaxY = 245;
      /* Interlineado */
      let interlineado = 5;
      /* Formato para alinear numeros a la derecha */
      let alignRight = {
        'align': 'right'
      }

      drawCabeceraResumen(doc, empresa, resumen, 
        fontName, fontBoldName, fontItalicName, fontBoldItalicName, this);
      
      let moneda = '';
      let importeVentas = 0;
      let importeComisiones = 0;
      let importeFacturado = 0;

      let positionY = positionRenglonesY;

      let posicionNroPresupuesto = 10;
      let posicionPresupuesto = 20;
      let posicionFechaVenta = 80;
      let posicionComprobanteVenta = 97;
      let posicionMontoVenta = 150;
      let posicionPjeFacturado = 162;
      let posicionCobrado = 166;
      let posicionPjeComision = 180;
      let posicionComision = 200;
  

      /* Titulo de los renglones */
      doc.setTextColor(60, 60, 60);
      doc.setFont(fontBoldName, 'bold');

      doc.text('Nro.', posicionNroPresupuesto, positionY);
      doc.text('Presupuesto', posicionPresupuesto, positionY);
      doc.text('Fecha', posicionFechaVenta, positionY);
      doc.text('Comprobante', posicionComprobanteVenta, positionY);
      doc.text('Monto Venta', posicionMontoVenta, positionY, alignRight);
      doc.text('% Fact', posicionPjeFacturado, positionY, alignRight);
      doc.text('C', posicionCobrado, positionY);
      doc.text('% Com', posicionPjeComision, positionY, alignRight);
      doc.text('Comisión', posicionComision, positionY, alignRight);

      let inicial = true;

      resumen.presupuestos.forEach(presupuesto => {
        if (positionY > positionMaxY) {
          /* Agregamos el footer */
          drawFooterEmpresa(doc, empresa, fontName);

          /* Agregamos una nueva pagina */
          doc.addPage();
          pages++;

          drawCabeceraResumen(doc, empresa, resumen, 
            fontName, fontBoldName, fontItalicName, fontBoldItalicName, this);
            
          positionY = positionRenglonesY;

          /* Titulo de los renglones */
          doc.setTextColor(60, 60, 60);
          doc.setFont(fontBoldName, 'bold');

          doc.text('Nro.', posicionNroPresupuesto, positionY);
          doc.text('Presupuesto', posicionPresupuesto, positionY);
          doc.text('Fecha', posicionFechaVenta, positionY);
          doc.text('Comprobante', posicionComprobanteVenta, positionY);
          doc.text('Monto Venta', posicionMontoVenta, positionY, alignRight);
          doc.text('% Fact', posicionPjeFacturado, positionY, alignRight);
          doc.text('C', posicionCobrado, positionY, alignRight);
          doc.text('% Com', posicionPjeComision, positionY, alignRight);
          doc.text('Comisión', posicionComision, positionY, alignRight);
        
          positionY += interlineado;
        } else {
          if (inicial) {
            positionY += 4;
            inicial = false;
          } else {
            positionY += interlineado;
          }
        }

        doc.setFontSize(7);
        doc.setFont(fontName, 'normal');
        doc.text(presupuesto.presupuestoNumero, posicionNroPresupuesto, positionY);

        // let presupuestoTitulo = `${presupuesto.cliente} ${presupuesto.accion}`;
        let presupuestoTitulo = presupuesto.accion.trim();
        if (presupuestoTitulo.length >= 30) {
          presupuestoTitulo = `${presupuestoTitulo.substring(0, 30)}...`;
        }

        doc.text(presupuestoTitulo, posicionPresupuesto, positionY);
        doc.text(this.$options.filters.fecha(presupuesto.fechaVenta), 
          posicionFechaVenta, positionY);
        doc.text(`${presupuesto.comprobanteVenta} ${presupuesto.numeroVenta}`, posicionComprobanteVenta, positionY);
        doc.text(this.$options.filters.moneda(presupuesto.montoVentaComisionable, presupuesto.moneda), 
          posicionMontoVenta, positionY, alignRight);
        // doc.text(this.$options.filters.moneda(presupuesto.montoVenta, presupuesto.moneda), 
        //   posicionMontoVenta, positionY, alignRight);
        doc.text(this.$options.filters.porcentaje(presupuesto.pjeFacturado), 
          posicionPjeFacturado, positionY, alignRight);
        
        if (presupuesto.ventaCobrada === '✔') {
          drawCheck(doc, posicionCobrado + 1, positionY);
        } else {
          doc.text(presupuesto.ventaCobrada, posicionCobrado, positionY);
        }
        
        if (presupuesto.tipoComision === 3) {
          doc.text('-', 
            posicionPjeComision, positionY, alignRight);
        } else {
          doc.text(this.$options.filters.porcentaje(presupuesto.pjeComision), 
            posicionPjeComision, positionY, alignRight);
        }       
        doc.text(this.$options.filters.moneda(presupuesto.totalComision, presupuesto.moneda), 
          posicionComision, positionY, alignRight);

        moneda = presupuesto.moneda;
        importeVentas += presupuesto.montoVenta;
        importeComisiones += presupuesto.totalComision;
        importeFacturado += presupuesto.totalCompras;
      });

      /* Totales  */
      positionY += interlineado;
      positionY += interlineado;

      doc.setFontSize(8);
      doc.setFont(fontBoldItalicName, 'bolditalic');
      doc.text('TOTALES:', 10, positionY);

      doc.text(this.$options.filters.moneda(importeVentas, moneda), 
        posicionMontoVenta, positionY, alignRight);
      doc.text(this.$options.filters.moneda(importeComisiones, moneda), 
        posicionComision, positionY, alignRight);

      doc.setFont(fontItalicName, 'italic');
      doc.setFontSize(7);
      positionY += 6;
      doc.text( `Los importes se abonan contra factura a mes vencido luego de ingresadas todas las cobranzas.`, 10, positionY);
      positionY += 4;
      doc.text( `Se excluyen órdenes correspondientes a RRHH y reembolsos.`, 10, positionY);
      positionY += 4;
      doc.text( `Montos sujetos a descuentos por gastos o impuestos en la emisión del pago.`, 10, positionY);

      /* Leyenda */
      doc.setFont(fontItalicName, 'italic');
      doc.setFontSize(7);
      positionY = 278;
      doc.text( `Valores precedidos por el símbolo $ están expresados en ${empresa.moneda}, y valores precedidos por el símbolo USD, en dólares estadounidenses.`, 10, positionY);

      drawFooterEmpresa(doc, empresa, fontName);

      /* Numeramos las páginas */
      for (let index = pages - 1; index >= 0; index--) {
        doc.setPage(index + 1);
        doc.setFont(fontName, 'normal');
        doc.setFontSize(6);
        doc.setTextColor(0, 0, 0);
        let cadena = new String().concat('Página ', (index + 1).toString(), " de ", pages.toString());
        doc.text(cadena, 10, 286);
      }

      window.open(doc.output("bloburl", { filename: pdfName + '.pdf' } ));
      //doc.save(pdfName + '.pdf');

      return;
    }
  }
}

function drawCheck(doc, x, y) {
  // y en jsPDF es línea base del texto; ajustamos para centrar el símbolo
  const yMid = y - 1.5;
  doc.setLineWidth(0.2);
  doc.setDrawColor(60, 60, 60);

  // trazo corto
  doc.line(x - 0.8, yMid + 0.2, x - 0.1, yMid + 1.0);
  // trazo largo
  doc.line(x - 0.1, yMid + 1.0, x + 1.2, yMid - 1.0);
}

function drawCabeceraResumen(doc, empresa, resumen, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName, pdf) {
  let alignRight = {
    'align': 'right'
  }

  drawCabeceraLogo(doc, empresa, fontName);

  /* Titulo */
  doc.setFont(fontName, 'normal');
  doc.setFontSize(20);
  // doc.setTextColor(232, 67, 113);
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  doc.text('Resumen de Movimientos', 62, 20);

  let positionY = 40;

  // doc.setDrawColor(151, 148, 149); 
  // doc.setLineWidth(0.3);
  // doc.line(10, positionY, 200, positionY);

  /* Datos del cliente */
  doc.setTextColor(60, 60, 60);
  
  doc.setFontSize(8);

  positionY = 45;
  doc.text(`Vendedor: ${resumen.nombre.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Fecha Desde: ${pdf.$options.filters.fecha(resumen.fechaDesde)}`, 10, positionY); 
  positionY += 4;
  doc.text(`Fecha Hasta: ${pdf.$options.filters.fecha(resumen.fechaHasta)}`, 10, positionY); 

  // positionY += 4;
  // doc.text(`Cond. Fiscal: ${certificado.clienteCondicionFiscal.trim()}`, 10, positionY);
  // doc.text(`${certificado.clienteDocumentoTipo}: ${certificado.clienteDocumentoNumero}`, 120, positionY);
  // positionY += 4;
  // doc.text(`Domicilio: ${certificado.clienteDireccion.trim()}`, 10, positionY);
  // positionY += 4;
  // if ((/true/i).test(certificado.showLocalidadCliente)) {
  //   doc.text(`Localidad: ${certificado.clienteLocalidad.trim()}`, 10, positionY);
  // } else {
  //   doc.text(`${certificado.clienteProvincia.trim()} - ${certificado.clientePais.trim()}`, 24, positionY);
  // }

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  doc.line(10, 58, 200, 58);
}